/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListRefundsGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type ListRefundsRequest = {
  accountID: string;
  /**
   * Identifier for the transfer.
   */
  transferID: string;
};

export type ListRefundsResponse = {
  headers: { [k: string]: Array<string> };
  result: Array<components.CardAcquiringRefund>;
};

/** @internal */
export const ListRefundsGlobals$inboundSchema: z.ZodType<
  ListRefundsGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type ListRefundsGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const ListRefundsGlobals$outboundSchema: z.ZodType<
  ListRefundsGlobals$Outbound,
  z.ZodTypeDef,
  ListRefundsGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function listRefundsGlobalsToJSON(
  listRefundsGlobals: ListRefundsGlobals,
): string {
  return JSON.stringify(
    ListRefundsGlobals$outboundSchema.parse(listRefundsGlobals),
  );
}
export function listRefundsGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<ListRefundsGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRefundsGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRefundsGlobals' from JSON`,
  );
}

/** @internal */
export const ListRefundsRequest$inboundSchema: z.ZodType<
  ListRefundsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  transferID: z.string(),
});
/** @internal */
export type ListRefundsRequest$Outbound = {
  accountID: string;
  transferID: string;
};

/** @internal */
export const ListRefundsRequest$outboundSchema: z.ZodType<
  ListRefundsRequest$Outbound,
  z.ZodTypeDef,
  ListRefundsRequest
> = z.object({
  accountID: z.string(),
  transferID: z.string(),
});

export function listRefundsRequestToJSON(
  listRefundsRequest: ListRefundsRequest,
): string {
  return JSON.stringify(
    ListRefundsRequest$outboundSchema.parse(listRefundsRequest),
  );
}
export function listRefundsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListRefundsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRefundsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRefundsRequest' from JSON`,
  );
}

/** @internal */
export const ListRefundsResponse$inboundSchema: z.ZodType<
  ListRefundsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: z.array(components.CardAcquiringRefund$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type ListRefundsResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: Array<components.CardAcquiringRefund$Outbound>;
};

/** @internal */
export const ListRefundsResponse$outboundSchema: z.ZodType<
  ListRefundsResponse$Outbound,
  z.ZodTypeDef,
  ListRefundsResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: z.array(components.CardAcquiringRefund$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function listRefundsResponseToJSON(
  listRefundsResponse: ListRefundsResponse,
): string {
  return JSON.stringify(
    ListRefundsResponse$outboundSchema.parse(listRefundsResponse),
  );
}
export function listRefundsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListRefundsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRefundsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRefundsResponse' from JSON`,
  );
}
